import React, { useRef } from 'react';
import { Query } from 'react-apollo';
import { addToDataLayerGTM } from '../../../utils/addToDataLayerGTM';
import { SkeletonCard } from '../../../components/Skeleton';
import { GET_TRAIL_HAS_USER_ITEM } from '../apollo';
import CourseCard from '../../../components/CourseCard';
import dimensionCard from '../../../assets/img/dimensionCard.png';
import ErrorModal from '../../../components/Modal/ErrorModal';

import Config from "../../../config/config";

const Card = ({ client, query, variables, type, item_trail, item, image }) => {
  const imgref = useRef(null);
  return (
    <Query
      client={client}
      variables={variables}
      query={query}
    >
      {({ loading, error, data }) => {
        if (loading)
          return <SkeletonCard><img ref={imgref} src={dimensionCard} /></SkeletonCard>;
        if (error) {
          // Google Tag Manager
          addToDataLayerGTM({
            'event': 'erro',
            'descricao': 'erro ao buscar cursos'
          });

          return <ErrorModal />;
        };
        const course = data.course || data.asset;

        return <CourseCard
          key={item_trail.id}
          min={imgref.current ? imgref.current.height : ''}
          item={item_trail}
          href={"/#/trail/" + course.id + "/" + item.item_type + "/" + item_trail.id}
          client={client}
          variables={{ trail_id: item_trail.id, course_trails:true }}
          userQuery={GET_TRAIL_HAS_USER_ITEM}
          type={type}
          src={
            Config.baseUrl + "/lms/assets/" + (
              image
            )
          }
        />
      }}
    </Query>
  );
}

export default Card;



// WEBPACK FOOTER //
// ./src/views/Trail/components/Card.jsx